module.exports = __webpack_public_path__ + "officialStatic/img/solution-value-seven1.663fa3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/solution/solution-value-seven1.png
// module id = evDn
// module chunks = 0